import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type BoardBottombarProps = ComponentPropsWithoutRef<'div'>;

export const BoardBottombar = memo(({ className, ...restOfProps }: BoardBottombarProps) => {
  return (
    <div
      className={cn(
        'sticky inset-x-0 bottom-0 z-30 flex h-12 w-full items-center justify-between ads:bg-glass/85 bg-gray-1/85 px-4 backdrop-blur-[18px]',
        className,
      )}
      {...restOfProps}
    />
  );
});

BoardBottombar.displayName = 'BoardBottombar';
